import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Header = styled.header`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  gap: 5px;
  margin: 10px 0 10px 10px;
  color: ${theme.colors.black};
`

export const Container = styled.div`
  margin: 15px;
  @media (min-width: 768px) {
    margin: 0 30%;
  }
`

export const WrapperHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`

export const Section = styled.section`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: ${theme.colors.green3};
  margin-bottom: 20px;
`
export const H3 = styled.h3`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
  color: ${theme.colors.green2};
  display: flex;
`

export const Article = styled.article`
  font-weight: 700;
`

export const AboutMeFieldWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
`

export const AboutMeLabel = styled.label`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.2px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
`

export const AboutMeTextarea = styled.textarea`
  width: 100%;
  height: 187px;
  border-radius: 16px;
  border: 1px solid ${theme.colors.gray200};
  background: ${theme.colors.white};
  box-shadow: 0px 3px 5px 0px rgba(175, 178, 187, 0.2);
  padding: 8px;
  padding-top: 30px;
  font-size: 18px;
  color: ${theme.colors.gray900};
  font-weight: 400;
`
